module.exports = __webpack_public_path__ + "img/savings-rafiki.95ed44ee.svg";